(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('toggleButton', {
            templateUrl: 'app/components/toggle-button/toggle-button.html',
            controller: toggleButtonController,
            bindings: {
                model: '=',
                label: '@',
                onChange: '&?'
            }
        });

    /** @ngInject */
    function toggleButtonController($timeout) {
        var $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.model = $ctrl.model || false;
        };

        $ctrl.toggle = function () {
            $ctrl.model = !$ctrl.model;
            if ($ctrl.onChange) {
                $timeout(function () {
                    $ctrl.onChange();
                });
            }
        };
    }
})();
